import ServicePageLayout from '@/components/ServicePageLayout';

const FASHION_DATA = {
  id: 'fashion',
  title: 'Fashion Services',
  subtitle: 'Editorial elegance meets bold creativity. Visuals that define brands and captivate audiences.',
  category: 'Fashion',
  heroImage: '/images/Fashion/Fashion_Hero.jpeg',
  sections: [
    {
      id: 'fashion-coverage',
      title: 'Fashion Coverage',
      items: [
        {
          title: 'Fashion Show Coverage',
          description: 'Front-row documentation of runway shows, backstage moments, and the energy of fashion events.',
          image: '/images/Fashion/Fashion_Show.jpg',
        },
        {
          title: 'Lookbook Photography',
          description: 'Clean, editorial-style photography for seasonal collections and brand lookbooks that sell.',
          image: '/images/Fashion/Lookbook_Photography.jpg',
        },
        {
          title: 'Street Style Photography',
          description: 'Authentic, trend-setting street style captures that bring fashion to life in real-world settings.',
          image: '/images/Fashion/Street_Style_Photography.jpg',
        },
      ],
    },
    {
      id: 'model-talent',
      title: 'Model & Talent',
      items: [
        {
          title: 'Model Portfolio',
          description: 'Professional portfolio shoots for aspiring and established models — versatile, agency-ready imagery.',
          image: '/images/Fashion/Model_Portfolio.jpg',
        },
        {
          title: 'Headshots & Comp Cards',
          description: 'Polished headshots and composite cards for modeling agencies, casting, and talent representation.',
          image: '/images/Fashion/Headshots_Comp_Cards.jpg',
        },
        {
          title: 'Actor & Artist Portraits',
          description: 'Expressive portrait sessions for actors, musicians, and creative professionals building their brand.',
          image: '/images/Fashion/Actor_Artist_Portraits.jpg',
        },
      ],
    },
    {
      id: 'brand-campaign',
      title: 'Brand & Campaign',
      items: [
        {
          title: 'Brand Campaign Photography',
          description: 'High-impact visual campaigns that communicate your brand message and connect with your audience.',
          image: '/images/Fashion/Brand_Campaign_Photography.png',
        },
        {
          title: 'Social Media Content',
          description: 'Platform-optimized fashion content for Instagram, Pinterest, and digital marketing campaigns.',
          image: '/images/Fashion/Social_Media_Content.jpg',
        },
        {
          title: 'Advertising & Print',
          description: 'Magazine-quality photography for print advertisements, billboards, and editorial placements.',
          image: '/images/Fashion/Advertising_&_Print.jpg',
        },
      ],
    },
    {
      id: 'product-catalog',
      title: 'Product & Catalog',
      items: [
        {
          title: 'Garment Photography',
          description: 'Clean, detailed product shots of clothing and accessories on models, mannequins, or flat-lay setups.',
          image: '/images/Fashion/Garment_Photography.jpg',
        },
        {
          title: 'Accessories & Jewelry',
          description: 'Macro and detail photography for jewelry, watches, handbags, and fashion accessories.',
          image: '/images/Fashion/Accessories_&_Jewelry.jpg',
        },
        {
          title: 'E-Commerce Catalog',
          description: 'High-volume product photography for online stores, marketplaces, and fashion e-commerce platforms.',
          image: '/images/Fashion/E-Commerce.jpg',
        },
      ],
    },
    {
      id: 'fashion-films',
      title: 'Films',
      items: [
        {
          title: 'Fashion Film',
          description: 'Cinematic short films that bring collections to life with narrative, mood, and artistic direction.',
          image: '/images/Fashion/Fashion_Film.png',
        },
        {
          title: 'Behind-the-Scenes',
          description: 'Engaging BTS content capturing the creative process — perfect for social media and brand storytelling.',
          image: '/images/Fashion/BTS.png',
        },
        {
          title: 'Runway & Showreel',
          description: 'Dynamic runway video coverage and curated showreels for designers, brands, and fashion weeks.',
          image: '/images/Fashion/Runway_&_Showreel.jpg',
        },
      ],
    },
    {
      id: 'fashion-addons',
      title: 'Add-Ons',
      items: [
        {
          title: 'Hair & Makeup Coordination',
          description: 'Professional styling team coordination for a seamless shoot experience throughout the entire process.',
          image: '/images/Fashion/Hair_&_Makeup.jpg',
        },
        {
          title: 'Location Scouting',
          description: 'Curated location options — urban, studio, outdoor, or exotic — tailored to your brand aesthetic.',
          image: '/images/Fashion/Location_Scouting.jpg',
        },
        {
          title: 'Advanced Retouching',
          description: 'Magazine-grade post-production with skin retouching, color grading, and composite work.',
          image: '/images/Fashion/Advanced_Retouching.jpg',
        },
      ],
    },
    {
      id: 'fashion-deliverables',
      title: 'Deliverables',
      items: [
        {
          title: 'High-Resolution Digital Files',
          description: 'Full-resolution edited images in multiple formats (JPEG, TIFF, PNG) for print and web use.',
          image: '/images/Fashion/High-Resolution_Digital_Files.jpg',
        },
        {
          title: 'Lookbook / Catalog Design',
          description: 'Optional layout design service for printed lookbooks, catalogs, and brand presentation decks.',
          image: '/images/Fashion/Catalog.jpg',
        },
        {
          title: 'Online Proofing Gallery',
          description: 'Secure online gallery for image selection, proofing, and approval with your team.',
          image: '/images/Fashion/Online_Gallery.jpg',
        },
      ],
    },
  ],
};

export default function FashionPage() {
  return <ServicePageLayout data={FASHION_DATA} />;
}
